import {ReactNode, useCallback, useState} from 'react';

import {Renderer} from '../../../../../libs/shared/helpers/src/react/reactHelpers';

/*
 * Hook.
 */

export function useChartTooltip<T>(
  renderer: (bounds: DOMRect, data: T) => ReactNode,
): [(d?: T, rectBounds?: DOMRect) => void, Renderer] {
  const [bounds, setBounds] = useState<DOMRect>();
  const [currentData, setCurrentData] = useState<T>();

  const setInfo = useCallback(
    (d?: T, rectBounds?: DOMRect) => {
      setCurrentData(d);
      setBounds(rectBounds);
    },
    [setBounds],
  );

  const maybeRenderTooltip = () => {
    if (!bounds || !currentData) {
      return null;
    }

    return renderer(bounds, currentData);
  };

  return [setInfo, maybeRenderTooltip];
}
